function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ml)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M372.34 0H121.876C111.145 0 102.446 8.69911 102.446 19.43V527.065C102.446 537.796 111.145 546.495 121.876 546.495H372.34C383.071 546.495 391.77 537.796 391.77 527.065V19.43C391.77 8.69911 383.071 0 372.34 0Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M378.909 60.007H115.307V486.488H378.909V60.007Z",
  fill: "white",
  stroke: "#1A2E35",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M275.764 30.156H218.452C217.415 30.156 216.42 29.7441 215.687 29.0108C214.954 28.2775 214.542 27.283 214.542 26.246V26.246C214.542 25.209 214.954 24.2145 215.687 23.4812C216.42 22.7479 217.415 22.336 218.452 22.336H275.764C276.801 22.336 277.796 22.7479 278.529 23.4812C279.262 24.2145 279.674 25.209 279.674 26.246V26.246C279.674 27.283 279.262 28.2775 278.529 29.0108C277.796 29.7441 276.801 30.156 275.764 30.156Z",
  fill: "#AAAAAA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.112 532.807C255.745 532.807 262.744 525.808 262.744 517.175C262.744 508.542 255.745 501.543 247.112 501.543C238.479 501.543 231.48 508.542 231.48 517.175C231.48 525.808 238.479 532.807 247.112 532.807Z",
  fill: "#AAAAAA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.031 509.249H239.186V525.094H255.031V509.249Z",
  fill: "#AAAAAA",
  stroke: "black",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.615 118.313V155.104L209.357 133.493H15.184C11.1576 133.493 7.29614 131.894 4.4487 129.047C1.60127 126.2 0.00106068 122.339 0 118.313L0 89.927C0 85.9 1.59974 82.0378 4.44729 79.1903C7.29484 76.3427 11.157 74.743 15.184 74.743H215.431C219.458 74.743 223.32 76.3427 226.168 79.1903C229.015 82.0378 230.615 85.9 230.615 89.927V118.313Z",
  fill: "#E3D7FF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M177.084 83.998H12.201C11.1401 83.998 10.28 84.8581 10.28 85.919C10.28 86.9799 11.1401 87.84 12.201 87.84H177.084C178.145 87.84 179.005 86.9799 179.005 85.919C179.005 84.8581 178.145 83.998 177.084 83.998Z",
  fill: "#AD7FE0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M94.452 100.253H11.242C10.711 100.253 10.27 99.395 10.27 98.332C10.27 97.269 10.703 96.411 11.242 96.411H94.452C94.983 96.411 95.424 97.269 95.424 98.332C95.416 99.395 94.984 100.253 94.452 100.253Z",
  fill: "#AD7FE0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M158.408 112.157H11.981C11.5016 112.126 11.054 111.906 10.7357 111.546C10.4173 111.187 10.2539 110.716 10.281 110.236V110.236C10.2539 109.756 10.4173 109.285 10.7357 108.926C11.054 108.566 11.5016 108.346 11.981 108.315H158.408C158.887 108.346 159.335 108.566 159.653 108.926C159.972 109.285 160.135 109.756 160.108 110.236V110.236C160.135 110.716 159.972 111.187 159.653 111.546C159.335 111.906 158.887 112.126 158.408 112.157V112.157Z",
  fill: "#AD7FE0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M218.604 100.253H107.804C107.09 100.253 106.513 99.395 106.513 98.332C106.513 97.269 107.09 96.411 107.804 96.411H218.574C219.288 96.411 219.865 97.269 219.865 98.332C219.895 99.395 219.316 100.253 218.604 100.253Z",
  fill: "#AD7FE0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M217.966 83.998H190.757C189.696 83.998 188.836 84.8581 188.836 85.919C188.836 86.9799 189.696 87.84 190.757 87.84H217.966C219.027 87.84 219.887 86.9799 219.887 85.919C219.887 84.8581 219.027 83.998 217.966 83.998Z",
  fill: "#AD7FE0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M132.314 124.061H11.685C10.926 124.061 10.285 123.203 10.285 122.14C10.285 121.077 10.915 120.219 11.685 120.219H132.314C133.073 120.219 133.714 121.077 133.714 122.14C133.718 123.203 133.088 124.061 132.314 124.061Z",
  fill: "#AD7FE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M481.511 149.346V177.736C481.511 181.763 479.911 185.625 477.064 188.473C474.216 191.32 470.354 192.92 466.327 192.92H272.189L250.931 214.535V149.346C250.932 145.32 252.532 141.46 255.378 138.613C258.225 135.767 262.085 134.167 266.111 134.166H466.331C470.357 134.167 474.217 135.767 477.064 138.613C479.91 141.46 481.51 145.32 481.511 149.346Z",
  fill: "#F3FFAB"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M469.323 143.421H304.44C303.379 143.421 302.519 144.281 302.519 145.342C302.519 146.403 303.379 147.263 304.44 147.263H469.323C470.384 147.263 471.244 146.403 471.244 145.342C471.244 144.281 470.384 143.421 469.323 143.421Z",
  fill: "#C6E547"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M387.071 159.683H470.271C470.802 159.683 471.243 158.825 471.243 157.762C471.243 156.699 470.81 155.841 470.271 155.841H387.071C386.54 155.841 386.099 156.699 386.099 157.762C386.099 158.817 386.532 159.683 387.071 159.683Z",
  fill: "#C6E547"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M263.686 171.58H410.113C410.592 171.549 411.04 171.329 411.358 170.969C411.677 170.61 411.84 170.139 411.813 169.659V169.659C411.84 169.179 411.677 168.708 411.358 168.349C411.04 167.989 410.592 167.769 410.113 167.738H263.686C263.207 167.769 262.759 167.989 262.441 168.349C262.122 168.708 261.959 169.179 261.986 169.659C261.959 170.139 262.122 170.61 262.441 170.969C262.759 171.329 263.207 171.549 263.686 171.58V171.58Z",
  fill: "#C6E547"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M262.918 159.683H373.686C374.4 159.683 374.977 158.825 374.977 157.762C374.977 156.699 374.4 155.841 373.686 155.841H262.918C262.204 155.841 261.627 156.699 261.627 157.762C261.628 158.817 262.205 159.683 262.918 159.683Z",
  fill: "#C6E547"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M290.758 143.421H263.549C262.488 143.421 261.628 144.281 261.628 145.342C261.628 146.403 262.488 147.263 263.549 147.263H290.758C291.819 147.263 292.679 146.403 292.679 145.342C292.679 144.281 291.819 143.421 290.758 143.421Z",
  fill: "#C6E547"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M263.366 183.492H384.003C384.762 183.492 385.403 182.634 385.403 181.571C385.403 180.508 384.773 179.65 384.003 179.65H263.366C262.607 179.65 261.966 180.508 261.966 181.571C261.962 182.626 262.592 183.492 263.366 183.492Z",
  fill: "#C6E547"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.817 559.584C72.723 476.026 148.507 439.784 148.507 439.784L180.059 456.084C181.167 456.084 174.145 486.019 174.145 486.019L127.401 506.719L84.127 573.658L51.2 562.271L59.817 559.584Z",
  fill: "#CA256A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.775 454.95C133.547 450.685 143.347 448.991 153.041 450.066C162.736 451.141 171.927 454.941 179.551 461.024C178.033 469.535 174.145 485.987 174.145 485.987L127.401 506.687L108.718 535.616C101.214 527.149 96.6991 516.451 95.868 505.167C95.0369 493.884 97.9355 482.64 104.118 473.164C110.551 466.598 117.455 460.511 124.775 454.95V454.95Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.556 488.477C102.074 445.749 153.032 438.909 153.032 438.909L212.01 424.393C212.01 424.393 221.735 488.819 147.341 489.893L182.522 559.557L150.188 573.633L153.035 563.87C153.035 563.87 99.653 513.979 100.556 488.477Z",
  fill: "#FF6498"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.007 424.393C212.007 424.393 221.732 488.819 147.338 489.893L182.519 559.557",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.575 307.567L309.055 373.147L247.636 378.461L244.083 418.577L252.601 410.059C252.601 410.059 344.555 429.229 365.859 410.059C387.163 390.889 336.212 319.547 336.212 319.547",
  fill: "#D5775E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308.236 337.153L309.048 373.147L270.761 376.463C269.291 383.725 268.558 391.116 268.574 398.525C268.572 403.409 268.886 408.288 269.515 413.132C286.4 415.88 312.881 419.365 334.449 418.446C335.633 411.877 336.223 405.215 336.21 398.54C336.215 367.794 324.133 342.255 308.236 337.153Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.741 307.567C326.741 307.567 333.908 424.545 313.668 479.905L317.897 486.115H281.884C281.884 486.115 277.951 337.315 277.951 305.205L326.741 307.567Z",
  fill: "#FA7F58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.737 307.567C326.737 307.567 333.904 424.547 313.664 479.905L317.893 486.115",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M314.779 217.723V232.923L295.951 237.554V211.9L314.779 207.269V217.723Z",
  fill: "#F8D6CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.143 222.977C304.42 222.977 304.644 222.753 304.644 222.476C304.644 222.199 304.42 221.975 304.143 221.975C303.866 221.975 303.642 222.199 303.642 222.476C303.642 222.753 303.866 222.977 304.143 222.977Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M311.879 222.977C312.156 222.977 312.38 222.753 312.38 222.476C312.38 222.199 312.156 221.975 311.879 221.975C311.602 221.975 311.378 222.199 311.378 222.476C311.378 222.753 311.602 222.977 311.879 222.977Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.609 225.482V217.723H313.499",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.194 217.723H307.081",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.189 221.686V224.386C296.495 224.382 295.83 224.104 295.34 223.613C294.849 223.121 294.573 222.456 294.57 221.762V221.519C294.613 221.188 294.78 220.886 295.038 220.674C295.296 220.461 295.625 220.355 295.958 220.376C296.291 220.398 296.603 220.545 296.832 220.788C297.061 221.031 297.188 221.352 297.189 221.686V221.686Z",
  fill: "#F8D6CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.189 224.389C296.494 224.385 295.829 224.107 295.339 223.615C294.848 223.123 294.572 222.457 294.57 221.762",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.909 229.377C307.202 229.377 306.524 229.096 306.025 228.596C305.525 228.097 305.244 227.419 305.244 226.712",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M314.779 232.923L295.951 237.554",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.61 225.49L307.909 225.908",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.189 216.417C297.189 216.417 300.734 214.306 300.651 210.556L307.081 212.492V209.964L313.496 212.492V209.964L316.153 211.027",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M314.78 217.723C314.78 217.723 319.107 215.347 318.045 208.613C314.955 207.082 311.552 206.285 308.104 206.285C304.655 206.285 301.252 207.082 298.162 208.613L299.111 204.813C299.111 204.813 294.229 206.825 295.087 209.664L291.887 209.899L294.567 211.812C294.567 211.812 290.634 216.2 295.88 220.399",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.576 381.673V424.393L152.022 439.273V391.673C152.022 383.472 154.771 375.508 159.83 369.054C164.889 362.599 171.966 358.027 179.929 356.067V356.067C183.809 355.111 187.856 355.05 191.763 355.89C195.671 356.729 199.336 358.446 202.481 360.911C205.627 363.376 208.17 366.525 209.919 370.118C211.668 373.712 212.576 377.656 212.575 381.652L212.576 381.673Z",
  fill: "#AD7FE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.612 406.37L161.212 390.37L144.722 392.405L152.048 417.125L167.414 415.06",
  fill: "#E3D7FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.612 406.37L161.212 390.37L144.722 392.405L152.048 417.125L167.414 415.06",
  stroke: "black",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M207.801 366.694C207.801 366.694 238.29 400.858 231.89 429.055C225.49 457.252 160.609 431.594 159.098 419.694C157.587 407.794 169.157 415.42 169.157 415.42C169.157 415.42 168.398 409.058 170.675 411.52C172.952 413.982 174.562 415.954 174.562 415.954L200.678 412.963L194.141 398.447",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.718 388.764C150.792 391.801 152.044 386.858 152.044 386.858C153.099 387.23 156.444 390.95 156.068 386.858C155.985 385.717 155.555 384.628 154.836 383.738C154.117 382.848 153.143 382.199 152.044 381.878C152.044 381.878 136.044 377.854 134.757 397.305C133.47 416.756 142.696 429.187 152.045 425.787",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.318 362.655C159.412 367.66 153.679 374.11 149.518 381.555",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.45 328.142V335.172C171.45 337.813 172.335 340.377 173.965 342.456C175.594 344.534 177.873 346.006 180.438 346.636L191.629 349.384V321.904L182.329 319.626C181.036 319.308 179.688 319.288 178.387 319.568C177.086 319.848 175.865 320.421 174.817 321.242C173.77 322.064 172.923 323.113 172.341 324.31C171.759 325.507 171.456 326.821 171.457 328.152L171.45 328.142Z",
  fill: "#FFD5E8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.45 335.172C171.45 337.813 172.335 340.377 173.965 342.456C175.594 344.534 177.873 346.006 180.438 346.636L191.629 349.384",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.846 333.775C183.144 333.775 183.385 333.534 183.385 333.236C183.385 332.938 183.144 332.697 182.846 332.697C182.548 332.697 182.307 332.938 182.307 333.236C182.307 333.534 182.548 333.775 182.846 333.775Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.563 333.775C174.861 333.775 175.102 333.534 175.102 333.236C175.102 332.938 174.861 332.697 174.563 332.697C174.265 332.697 174.024 332.938 174.024 333.236C174.024 333.534 174.265 333.775 174.563 333.775Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.992 336.455V328.142H172.832",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.863 328.142H179.703",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.301 332.401V335.286C191.048 335.286 191.765 334.989 192.293 334.461C192.821 333.933 193.118 333.216 193.118 332.469C193.118 332.383 193.118 332.297 193.118 332.211C193.07 331.856 192.888 331.532 192.61 331.306C192.332 331.079 191.979 330.966 191.621 330.991C191.263 331.015 190.928 331.174 190.683 331.436C190.438 331.697 190.301 332.042 190.301 332.401V332.401Z",
  fill: "#FFD5E8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.301 335.286C191.048 335.286 191.765 334.989 192.293 334.461C192.821 333.933 193.118 333.216 193.118 332.469",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.27 340.069C179.443 340.242 179.649 340.38 179.876 340.474C180.103 340.568 180.346 340.616 180.591 340.616C180.836 340.616 181.079 340.568 181.306 340.474C181.533 340.38 181.739 340.242 181.912 340.069",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.992 336.462L178.814 336.91",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.45 333.236C171.45 333.236 165.695 328.324 168.11 321.985C170.388 316.04 182.31 312.047 189.026 316.238C189.971 316.836 190.97 317.344 192.01 317.756C196.31 319.434 207.194 326.001 206.587 349.422C205.828 378.568 188.009 363.991 189.664 357.394C191.319 350.797 192.458 345.285 191.63 339.583",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.673 364.917C191.485 366.08 192.554 367.039 193.797 367.722C195.04 368.404 196.423 368.79 197.84 368.85",
  stroke: "#FF6498",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.241 366.17C190.241 366.17 178.602 368.835 177.896 381.453C177.722 384.441 176.92 387.359 175.542 390.017C173.614 393.752 171.617 399.469 173.659 404.692C177.068 413.4 197.748 388.217 195.425 370.186",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M278.262 264.847V306.155L336.781 320.534V274.527C336.781 266.601 334.123 258.905 329.233 252.667C324.344 246.43 317.504 242.012 309.807 240.12V240.12C306.058 239.199 302.148 239.143 298.374 239.956C294.6 240.768 291.06 242.428 288.022 244.81C284.984 247.192 282.528 250.234 280.838 253.705C279.148 257.177 278.27 260.986 278.27 264.847H278.262Z",
  fill: "#C6E547"
}), /*#__PURE__*/React.createElement("path", {
  d: "M323.67 288.717L327.922 273.244L343.858 275.21L336.782 299.102L321.932 297.102",
  fill: "#E3D7FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M323.67 288.717L327.922 273.244L343.858 275.21L336.782 299.102L321.932 297.102",
  stroke: "black",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.901 250.354C282.901 250.354 253.436 283.372 259.647 310.619C265.858 337.866 328.529 313.079 329.987 301.577C331.445 290.075 320.269 297.447 320.269 297.447C320.269 297.447 320.975 291.297 318.834 293.647C316.693 295.997 315.034 297.936 315.034 297.936L289.798 295.043L296.115 281.021",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.857 271.695C337.973 274.603 336.781 269.858 336.781 269.858C335.764 270.215 332.529 273.813 332.894 269.858C332.973 268.754 333.387 267.701 334.082 266.84C334.777 265.978 335.719 265.35 336.781 265.04C336.781 265.04 352.238 261.153 353.481 279.94C354.724 298.727 345.806 310.733 336.781 307.469",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M322.979 246.467C329.652 251.305 335.191 257.538 339.211 264.733",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.454 320.314C173.454 320.314 185.487 324.814 193.117 323.837L191.599 327.906",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.094 245.207L317.111 286.955L314.158 294.676L306.733 288.32L307.233 245.509L304.621 241.759H310.862L309.094 245.207Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ml"
}, /*#__PURE__*/React.createElement("rect", {
  width: 481.515,
  height: 573.659,
  fill: "white"
})));

var SvgMobileLg = function SvgMobileLg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 482,
    height: 574,
    viewBox: "0 0 482 574",
    fill: "none",
    className: "hidden md:block absolute right-0 mt-16 mr-20 w-96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileLg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MobileLg.917f82bd.svg";
export { ForwardRef as ReactComponent };